// i18n setup. Loads translations, auto-detects browser language, and toggles
// the document's text direction for RTL languages (ar, ur).
//
// Languages supported here MUST match the AI feedback languages in
// `frontend/src/api/client.ts` and the picker labels below.

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import ar from './locales/ar.json'
import ur from './locales/ur.json'
import ms from './locales/ms.json'
import tr from './locales/tr.json'
import fr from './locales/fr.json'
import id from './locales/id.json'
import bn from './locales/bn.json'
import es from './locales/es.json'

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸', dir: 'ltr' as const },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' as const },
  { code: 'ur', label: 'اردو', flag: '🇵🇰', dir: 'rtl' as const },
  { code: 'ms', label: 'Melayu', flag: '🇲🇾', dir: 'ltr' as const },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷', dir: 'ltr' as const },
  { code: 'fr', label: 'Français', flag: '🇫🇷', dir: 'ltr' as const },
  { code: 'id', label: 'Indonesia', flag: '🇮🇩', dir: 'ltr' as const },
  { code: 'bn', label: 'বাংলা', flag: '🇧🇩', dir: 'ltr' as const },
  { code: 'es', label: 'Español', flag: '🇪🇸', dir: 'ltr' as const },
]

const RTL_LANGS = new Set(['ar', 'ur'])

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      ur: { translation: ur },
      ms: { translation: ms },
      tr: { translation: tr },
      fr: { translation: fr },
      id: { translation: id },
      bn: { translation: bn },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false }, // React handles XSS
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tajweed_ui_lang',
    },
  })

function applyDirection(lng: string) {
  const dir = RTL_LANGS.has(lng) ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('dir', dir)
  document.documentElement.setAttribute('lang', lng)
}

// Apply on initial load and on every change
applyDirection(i18n.language)
i18n.on('languageChanged', applyDirection)

export default i18n
